import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { MAX_NUMBER_OF_THUMBNAILS } from './constants';
import { GalleryIndicatorElement } from './gallery-indicator.styled';
import { GalleryNext, GalleryPrevious } from './gallery-sliders.styled';
const INDICATOR_OFFSET_BOTTOM = -33;
const NAVIGATION_BUTTON_SIZE = 55;
export const galleryContainerStyles = ({ theme, $variant, $withThumbnails = false, }) => css `
	position: relative;
	z-index: 0;
	display: grid;
	grid-template-areas:
		'slide slide slide slide slide'
		'thumb1 thumb2 thumb3 thumb4 thumb5';
	grid-template-columns: repeat(${MAX_NUMBER_OF_THUMBNAILS}, 1fr);
	grid-template-rows: auto;
	grid-column-gap: ${pxToRem(theme.spacing['200'])};
	justify-content: stretch;
	align-items: stretch;
	margin-bottom: ${pxToRem(theme.spacing['200'])};
	height: auto;

	&:focus {
		outline: none;
	}

	${$withThumbnails &&
    css `
		height: 100%;
		margin-bottom: ${pxToRem(theme.spacing['400'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin-bottom: ${pxToRem(theme.spacing['200'])};
		}

		${GalleryIndicators} {
			visibility: initial;
			bottom: ${pxToRem(INDICATOR_OFFSET_BOTTOM)};

			${GalleryIndicatorElement} {
				border-radius: 0;
				background-color: unset;

				&:first-of-type,
				&:last-of-type {
					&::before {
						display: none;
					}
				}
			}

			@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
				visibility: hidden;
			}
		}
	`}

	${$variant === 'blue_square' &&
    css `
		${GalleryPrevious},
		${GalleryNext} {
			border-radius: 0;
			background-color: transparent;
			background-size: cover;
			border: none;
			width: ${pxToRem(NAVIGATION_BUTTON_SIZE)};
			height: ${pxToRem(NAVIGATION_BUTTON_SIZE)};
		}

		${GalleryPrevious} {
			left: 0;
			background-color: ${theme.colors.base.bgGalleryButton};
			color: ${theme.colors.blanc.bgPanelReview};
			border-radius: 0 ${pxToRem(theme.borderRadius.s)} ${pxToRem(theme.borderRadius.s)} 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		${GalleryNext} {
			right: 0;
			background-color: ${theme.colors.base.bgGalleryButton};
			color: ${theme.colors.blanc.bgPanelReview};
			border-radius: ${pxToRem(theme.borderRadius.s)} 0 0 ${pxToRem(theme.borderRadius.s)};
			display: flex;
			align-items: center;
			justify-content: center;
		}
	`}

  /* Deprecated styles */
  .PONCHO-gallery__zoom-control-button {
		background-color: ${theme.colors.blanc.bgPanelReview};
		border-radius: 50%;
		height: 40px;
		width: 40px;
		padding: 0;
		position: relative;

		> span {
			position: absolute;
			top: 8px;
			left: 10px;
		}
	}
`;
export const GalleryContainer = styled.div `
	${galleryContainerStyles}
`;
/**
 * Gallery indicators
 */
export const galleryIndicatorsStyles = () => css `
	width: 100%;
	height: auto;
	bottom: 0;
	grid-area: slide;
	text-align: center;
	position: absolute;
	display: inline-block;
`;
export const GalleryIndicators = styled.span `
	${galleryIndicatorsStyles}
`;
//# sourceMappingURL=gallery.styled.js.map